import { useMutation, useQueryClient } from "@tanstack/react-query";
import giftCategoriesClient from "../../../../api/giftCategories";

const useDeleteLogoMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => giftCategoriesClient.deleteLogo(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["logos"] });
    },
  });
};

export default useDeleteLogoMutation;
